module.exports = "/_next/static/images/e0e7fe9f50d4d40fa50755463f781c9f-comunidad-logo.jpg";